import React from 'react';
import GrowthPlanSVG from '@birdi/icons/growth-plan-2.svg';
import { PlanOption, PlanData, PaymentIntervalOption } from './plan-option';

interface GrowthPlanOptionProps {
  product: PlanData | null | undefined;
  displayInterval: PaymentIntervalOption;
  currency: string;
}

export const GrowthPlanOption = (props: GrowthPlanOptionProps): JSX.Element => {
  const { product, displayInterval, currency } = props;

  const features = [
    '3 users + 50 guest seats',
    '5 workspace + 500 GB storage',
    '240 GP processing incl. annually',
    'Extra processing - Custom add-on',
    // 'Upload your own 3D models',
    // 'Create & measure volumes',
    // 'Style rasters & vectors',
    // 'Base map library',
    // 'Multi-user (real-time collaboration)',
    // 'User roles and permissions',
    // 'Add-ons available',
    // 'Email support'
  ];

  return (
    <PlanOption
      title="Growth"
      icon={GrowthPlanSVG}
      subtitle="For small teams"
      description="Powerful visualization, team collaboration & advanced outputs — for teams that need their geospatial workflows to scale across people, projects, and sites."
      headerText="All the Plus plan features plus:"
      features={features}
      themeColor="lightCanary"
      planData={product}
      displayInterval={displayInterval}
      currency={currency}
      withHeader="Small teams"
      annualBillingOnly={true}
    />
  );
};
